import { render, staticRenderFns } from "./OnsaleHome.vue?vue&type=template&id=be68fffa&"
import script from "./OnsaleHome.vue?vue&type=script&lang=js&"
export * from "./OnsaleHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports